import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isNull from 'lodash/isNull';

import lazyGettext from 'js-utils/lazy-gettext';
import Button from 'eventbrite_design_system/button/Button';
import { SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE } from './constants';

import { SIZE_BLOCK } from 'eventbrite_design_system/button/constants';

export default class GoogleLoginButton extends Component {
    static propTypes = {
        onSocialConnectVerified: PropTypes.func,
        onSocialConnectNotAuthorized: PropTypes.func,
        onLoadComplete: PropTypes.func,
        onClick: PropTypes.func,
    };

    componentDidMount() {
        ((doc, tagName, id, googleInit) => {
            const firstScriptTag = doc.getElementsByTagName(tagName)[0];
            if (isNull(doc.getElementById(id))) {
                // if the script tag is not present
                const scriptTag = doc.createElement('script');
                scriptTag.id = id;
                scriptTag.src = 'https://apis.google.com/js/platform.js';
                firstScriptTag.parentNode.insertBefore(
                    scriptTag,
                    firstScriptTag,
                );
            }

            if (googleInit) {
                googleInit();
            }
        })(document, 'script', 'google-id-auth', this.googleInit);
    }

    googleInit = () => {
        const { clientId, scope } = this.props;

        /*eslint-disable no-undef*/
        if (gapi) {
            gapi.load('auth2', function () {
                gapi.auth2 &&
                    gapi.auth2.init({
                        client_id: clientId,
                        scope: scope,
                    });
            });
        }
    };

    signOut = () => {
        /*eslint-disable no-undef*/
        if (gapi) {
            const auth2 = gapi.auth2 && gapi.auth2.getAuthInstance();

            auth2.signOut().then(function () {
                console.log('User signed out.');
            });
        }
    };

    onSignInClicked = () => {
        const { onSocialConnectVerified } = this.props;

        /*eslint-disable no-undef*/
        if (gapi) {
            const auth2 = gapi.auth2 && gapi.auth2.getAuthInstance();

            gapi.load('auth2', function () {
                auth2.signIn().then(
                    (googleUser) => {
                        console.log(
                            'Logged in as: ' +
                                googleUser.getBasicProfile().getName(),
                        );

                        onSocialConnectVerified({
                            accessToken: googleUser.getAuthResponse().id_token,
                            email: googleUser.getBasicProfile().getEmail(),
                            firstName: googleUser
                                .getBasicProfile()
                                .getGivenName(),
                            lastName: googleUser
                                .getBasicProfile()
                                .getFamilyName(),
                            picture: googleUser.getBasicProfile().getImageUrl(),
                            sourceProvider: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
                        });
                    },
                    function (error) {
                        console.log('user failed to sign in');
                        // onFailure
                    },
                );
            });
        }
    };

    onFailure = (error) => {
        console.log(error);
    };

    render() {
        return (
            <div className="">
                <Button
                    type="button"
                    size={SIZE_BLOCK}
                    onClick={this.onSignInClicked.bind(this)}
                >
                    {lazyGettext('Continue with Google')}
                </Button>
            </div>
        );
    }
}
